var $8cac5fbfa7515028$exports = {};
$8cac5fbfa7515028$exports = {
    "help": `Help`,
    "info": `Informatie`
};


export {$8cac5fbfa7515028$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
